import { h, JSX } from "preact"

/**
 * @group Components
 */
export interface TrackProps {
    /** Vertical mode? */
    vertical: boolean
    /** Continuous value interval? */
    included: boolean
    /** Track index */
    index: number
    /** Track offset, % */
    offset: number
    /** Track length, % */
    length: number
    /** Prefix for class names */
    classesPrefix: string
}

/**
 * Track line in range.
 *
 * @group Components
 */
export function Track({ vertical, included, index, offset, length, classesPrefix }: TrackProps) {
    const style: JSX.CSSProperties = {}

    if (!included) {
        style.visibility = "hidden"
    }

    if (vertical) {
        style.bottom = `${offset}%`
        style.height = `${length}%`
    } else {
        style.left = `${offset}%`
        style.width = `${length}%`
    }

    return <div class={`${classesPrefix}track ${classesPrefix}track-${index}`} style={style} />
}
